import styles from './user-security.module.scss';

import React from 'react';
import { VStack, Text } from 'native-base';
import { PrimaryButton, Setup2FA, ToggleSwitch } from '../../';

// Redux
import { useAppDispatch, openModal } from '@breakroom-nx/redux';

// Classes & Types
import { getAuth, multiFactor } from 'firebase/auth';

/* eslint-disable-next-line */
export interface UserSecurityProps {}

export function UserSecurity(props: UserSecurityProps) {
  const auth = getAuth();
  const dispatch = useAppDispatch();

  const enrolledIn2FA = () => {
    if (auth.currentUser) {
      const hasMultiFactor = multiFactor(auth.currentUser).enrolledFactors.some(
        (factor) => factor.factorId === 'phone'
      );
      return hasMultiFactor;
    }
    return false;
  };

  return (
    <VStack space={5} alignItems={'stretch'} justifyContent={'flex-start'}>
      <Text
        fontFamily={'heading'}
        fontSize={26}
        color={'white'}
        fontWeight={600}
        mb={'3px'}
      >
        Security
      </Text>

      {enrolledIn2FA() ? (
        <ToggleSwitch
          title="Enable Two-Factor Authentication"
          description="Decide if you want authentication and security related changes to your account to require an SMS code."
          on={true}
          disabled={false}
          onToggle={() => {
            // console.log(`Toggled Switch`);
          }}
          key={'twoFactor'}
        />
      ) : (
        <Setup2FA />
      )}

      <PrimaryButton
        text={'Change Password'}
        onPress={() => {
          dispatch(openModal({ modalType: 'ChangePassword' }));
        }}
        fontSize={14}
        style={{
          color: 'red',
        }}
      />
    </VStack>
  );
}

export default UserSecurity;
